import { call } from 'redux-saga/effects';

export function* getUserInfo(response) {
  // Avoid breaking production with the firebase sdk update to v9
  if (response.additionalUserInfo) {
    return response.additionalUserInfo;
  }
  return yield call(window.FIREBASE.getAdditionalUserInfo, response);
}
